/**
 * @generated SignedSource<<0bfc903c52598c764ca59e1e8db87e0a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventConnectionOrder = "CREATED_AT" | "ORDERING_PRIORITY";
export type EventConnectionSortDirection = "ASCENDING" | "DESCENDING";
export type EventStatus = "ACTIVE" | "CLOSED" | "UPCOMING";
export type LocationKind = "HYBRID" | "IN_PERSON" | "ONLINE";
export type RewardKind = "BADGE" | "LEARNING" | "MONEY" | "SWAG";
export type EventQueryFilters = {
  locations?: ReadonlyArray<LocationKind> | null | undefined;
  order?: EventConnectionOrder;
  rewards?: ReadonlyArray<RewardKind> | null | undefined;
  search?: string | null | undefined;
  sortDirection?: EventConnectionSortDirection;
  status?: EventStatus | null | undefined;
  tags?: ReadonlyArray<string> | null | undefined;
};
export type EventFiltersTotalCountFragmentPaginationQuery$variables = {
  filters?: EventQueryFilters | null | undefined;
};
export type EventFiltersTotalCountFragmentPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EventFiltersTotalCountFragment">;
};
export type EventFiltersTotalCountFragmentPaginationQuery = {
  response: EventFiltersTotalCountFragmentPaginationQuery$data;
  variables: EventFiltersTotalCountFragmentPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  }
],
v1 = {
  "kind": "Variable",
  "name": "filters",
  "variableName": "filters"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventFiltersTotalCountFragmentPaginationQuery",
    "selections": [
      {
        "args": [
          (v1/*:: as any*/)
        ],
        "kind": "FragmentSpread",
        "name": "EventFiltersTotalCountFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "EventFiltersTotalCountFragmentPaginationQuery",
    "selections": [
      {
        "alias": "eventCount",
        "args": [
          (v1/*:: as any*/),
          {
            "kind": "Literal",
            "name": "first",
            "value": 0
          }
        ],
        "concreteType": "EventConnection",
        "kind": "LinkedField",
        "name": "events",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bbdfa3943efe472f70d08274d76d2e0f",
    "id": null,
    "metadata": {},
    "name": "EventFiltersTotalCountFragmentPaginationQuery",
    "operationKind": "query",
    "text": "query EventFiltersTotalCountFragmentPaginationQuery(\n  $filters: EventQueryFilters\n) {\n  ...EventFiltersTotalCountFragment_VTAHT\n}\n\nfragment EventFiltersTotalCountFragment_VTAHT on Query {\n  eventCount: events(first: 0, filters: $filters) {\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "b064528b125aba506ab6db236b4705a4";

export default node;
